export default "__VITE_ASSET__ByCj1GI7__"